var _NETWORK_ERROR_MESSAG;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import { getLocale } from '@miotech/shared';
import { message } from 'antd';
import { EUserLanguage } from "../rematch/types";

// axios 所有网络异常错误 见 https://github.com/axios/axios?tab=readme-ov-file#error-types
var AXIOS_NETWORK_ERROR_CODES = ['ERR_NETWORK', 'ETIMEDOUT', 'ECONNABORTED'];

// 避免网络异常时，i18n还没加载，文案写死配置
var NETWORK_ERROR_MESSAGE_MAP = (_NETWORK_ERROR_MESSAG = {}, _defineProperty(_NETWORK_ERROR_MESSAG, EUserLanguage.ZH_CN, '网络异常，请求超时，请稍后重试'), _defineProperty(_NETWORK_ERROR_MESSAG, EUserLanguage.ZH_HK, '網路異常，請求逾時，請稍後重試'), _defineProperty(_NETWORK_ERROR_MESSAG, EUserLanguage.EN_US, 'Network error, please try again later'), _NETWORK_ERROR_MESSAG);

/**
 * axios 请求错误拦截，统一处理以下场景
 * 1 401 error 统一跳转到登录页面
 * 2 网络错误，展示统一文案
 * @param error AxiosError
 * @returns boolean 是否已处理，已处理的错误子站无需再处理
 */
export function axiosErrorInterceptor(error) {
  var _error$response;
  if ((error === null || error === void 0 || (_error$response = error.response) === null || _error$response === void 0 ? void 0 : _error$response.status) === 401) {
    setTimeout(function () {
      window.location.href = "/hub/user/login?redirect-url=".concat(encodeURIComponent(window.location.pathname + window.location.search));
    }, 500);
    return true;
  }
  if (AXIOS_NETWORK_ERROR_CODES.includes(String(error.code))) {
    message.error(NETWORK_ERROR_MESSAGE_MAP[getLocale()]);
    return true;
  }
}